







































































































































































import { Component, Vue } from 'vue-property-decorator';
import OrganizationIcon from '@/components/common/OrganizationIcon.vue';
import { vxm } from '@/store';
import { Account } from '@/@types/Account';
import { CreateOrganizationResult } from '@/@types/Organization';

@Component({
  components: {
    OrganizationIcon,
  },
})
export default class OrganizationBasicConfig extends Vue {
  private isOpenUpdateOrganizationIconModal: boolean = false;
  private organizationIconColor: string = 'light-blue lighten-3';
  private organizationIconSize: number = 200;
  private Prefectures: {label:string,value:string}[] = [];

  private selectedAccount: Account | null = null;
  private selectedOrganization: CreateOrganizationResult = {
    organizationId: 0,
    organizationName: "",
    organizationIcon: "",
    organizationComment: "",
    sectorCd: "",
    billingPlan: "",
    organizationEmail: "",
    organizationPhoneNumber: "",
    organizationPerson: "",
    prefectureCd: "",
    cityCd: "",
    organizationStreetAddress: "",
    deleteFlag: false,
  };

  private async created() {
    this.selectedAccount = vxm.theoryApi.accountsStore.getAccountDetail?.results ?? null;
    await vxm.theoryApi.organizationsStore.findOneOrganization(vxm.theoryApi.authStore.getCurrentOrganizationId!);
    this.selectedOrganization = vxm.theoryApi.organizationsStore.getOrganization
    const prefectures = vxm.theoryApi.mastersStore.getPrefecture;
    if (prefectures) {
      this.Prefectures =prefectures.map(x => {
        return {label:x.prefectureName,value:x.prefectureCd.toString()}
      });
    };
  }

  private openExplorer(): void {
    const iconExplorer = this.$refs.iconExplorer as HTMLElement;
    iconExplorer.click();
  }

  private readProfileImage(event: Event): void {
    const target = event.target as HTMLInputElement;
    const files = target.files;
    if (!files!.length) {
      this.isOpenUpdateOrganizationIconModal = false;
      return;
    }

    const reader = new FileReader();
    reader.onload = (loadEvent): void => {
      if (loadEvent.target) {
        (this as any).$refs.iconRef.bind({
          url: loadEvent.target.result,
        });
      }
    };
    this.isOpenUpdateOrganizationIconModal = true;
    reader.readAsDataURL(files![0]);
  }

  private saveChanges(): void {
    vxm.theoryApi.organizationsStore.updateOrganization({ organizationId: this.selectedOrganization.organizationId, updateOrganizationDto: {
      organizationName: this.selectedOrganization.organizationName,
      prefectureCd: this.selectedOrganization.prefectureCd,
      cityCd: this.selectedOrganization.cityCd,
      organizationStreetAddress: this.selectedOrganization.organizationStreetAddress,
      organizationPhoneNumber: this.selectedOrganization.organizationPhoneNumber,
      organizationEmail:this.selectedOrganization.organizationEmail,
      organizationPerson:this.selectedOrganization.organizationPerson,
      sectorCd:this.selectedOrganization.sectorCd,
      organizationComment:this.selectedOrganization.organizationComment,
      organizationIcon: this.selectedOrganization.organizationIcon
    }});
  }
}
